const build = (path) => `${path}`;

export const DASHBOARD_PATH = "/";
export const ORDERS_PATH = "orders";
export const LOGIN_PATH = "login";
export const ADMIN_FEE_PATH = "admin-fee";
export const INVOICE_PATH = "invoice";
export const INVOICE_FORM_PATH = "generate-invoice";
export const CONFIGURATION_PATH = "configuration";
export const ADD_NEW_SITE_PATH = "add-new-site";
export const EDIT_CONFIG_PATH = "edit-config";
export const PRODUCTS_IMPORT_EXPORT_PATH = "products";
export const INQUIRY_PATH = "/inquiry";
export const EDIT_INQUIRY_PATH = `${INQUIRY_PATH}/:inquiryId`;
export const SALES_LEADS_PATH = "/sales-leads";
export const ADD_SALES_LEADS_PATH = "/add-sales-leads";
export const EDIT_SALES_LEADS_PATH = "/edit-sales-leads/:id";
export const USER_ROLE_PATH = "/permissions";
export const SALES_USER_PATH = "/sales-user";
export const CREATE_SALES_USER_PATH = "/create-sales-user";
export const EDIT_SALES_USER_PATH = "/edit-sales-user";
export const REQUEST_SALES_LEAD_PATH = "/request-sales-lead/:type";
export const EDIT_REQUEST_SALES_LEAD_PATH = "/request-sales-lead/:type/:id";
export const STAFF_USER_PATH = "/staff-user";
export const CREATE_STAFF_USER_PATH = "/create-staff-user";
export const EDIT_STAFF_USER_PATH = "/edit-staff-user";

export const buildDashboardPath = () => build(DASHBOARD_PATH);
export const buildLoginPath = () => build(LOGIN_PATH);
export const buildOrderPath = () => build(ORDERS_PATH);
export const buildAdminFeePath = () => build(ADMIN_FEE_PATH);
export const buildInvoicePath = () => build(INVOICE_PATH);
export const buildInvoiceFormPath = () => build(INVOICE_FORM_PATH);
export const buildConfigurationPath = () => build(CONFIGURATION_PATH);
export const buildAddNewSitePath = () => build(ADD_NEW_SITE_PATH);
export const buildEditConfigPath = () => build(EDIT_CONFIG_PATH);
export const buildProductImportExportPath = () => build(PRODUCTS_IMPORT_EXPORT_PATH);
export const buildInquiryPath = () => build(INQUIRY_PATH);
export const buildEditInquiryPath = (inquiryId) =>
  build(EDIT_INQUIRY_PATH.replace(":inquiryId", `${inquiryId}`));
export const buildSalesLeadsPath = () => build(SALES_LEADS_PATH);
export const buildAddSalesLeadsPath = () => build(ADD_SALES_LEADS_PATH);
export const buildEditSalesLeadsPath = (id) => build(EDIT_SALES_LEADS_PATH.replace(":id", `${id}`));
export const buildRequestSalesLeadPath = (type) =>
  build(REQUEST_SALES_LEAD_PATH.replace(":type", `${type}`));
export const buildEditRequestSalesLeadPath = (type, id) =>
  build(EDIT_REQUEST_SALES_LEAD_PATH.replace(":type", `${type}`).replace(":id", `${id}`));
export const buildUserRolePath = () => build(USER_ROLE_PATH);

export const buildSalesUserPath = () => build(SALES_USER_PATH);
export const buildCreateSalesUserPath = () => build(CREATE_SALES_USER_PATH);
export const buildEditSalesUserPath = (id) => build(EDIT_SALES_USER_PATH.replace(":id", `${id}`));

export const buildStaffUserPath = () => build(STAFF_USER_PATH);
export const buildCreateStaffUserPath = () => build(CREATE_STAFF_USER_PATH);
export const buildEditStaffUserPath = () => build(EDIT_STAFF_USER_PATH);
